export default "__VITE_ASSET__xnRmkECs__"